import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { FinalDocumentProgress } from '../../types/finalDocumentation';

const OUTSTANDING_LABEL = { MISSING: 'not uploaded', PENDING: 'pending review', REJECTED: 'rejected' } as const;

/** "Approved 8/12" — green once every applicable item's document is
 * approved. Hover lists what's still outstanding and why. */
export const FinalDocumentProgressChip = ({
  progress,
  onClick,
}: {
  progress: FinalDocumentProgress;
  onClick?: () => void;
}) => (
  <Tooltip
    title={
      progress.complete ? (
        'Every applicable document is approved'
      ) : (
        <Box>
          {progress.outstanding.slice(0, 8).map((o) => (
            <Typography key={o.key} variant="caption" component="div">
              {o.label.split(' — ')[0]} — {OUTSTANDING_LABEL[o.status]}
            </Typography>
          ))}
          {progress.outstanding.length > 8 && (
            <Typography variant="caption">+{progress.outstanding.length - 8} more</Typography>
          )}
        </Box>
      )
    }
  >
    <Chip
      size="small"
      color={progress.complete ? 'success' : progress.uploaded > 0 ? 'warning' : 'default'}
      label={`Approved ${progress.approved}/${progress.total}`}
      onClick={
        onClick
          ? (e) => {
              // Inside a clickable grid row: open the checklist, not the row.
              e.stopPropagation();
              onClick();
            }
          : undefined
      }
    />
  </Tooltip>
);
